/* eslint-disable import/prefer-default-export */
import { get, post, patch, download } from '@src/services/NetworkUtils'

// Company enrollment wizard (steps 1-3 + draft). Step 4 (DocuSign) endpoints
// are listed for completeness — the embedded-signing integration is handled
// by another developer (see StepMembershipAgreement TODO).
export const RegisterCompanyService = {
  // ─── Enrollment steps ─────────────────────────────────────────────────────
  // Steps 1-3 are multipart (logo / legal docs / authority letter), so they MUST
  // pass the 'form-data' content-type — getHeader('json') would set
  // application/json and break multer's file parsing on the BE.
  createCompany: async (formData, { draft = false } = {}) =>
    await post(`/v1/company${draft ? '?draft=true' : ''}`, formData, 'form-data'),
  // Resume path: update step 1 of an already-created (draft) company. POSTing
  // create again 409s on the duplicate legal name, so re-submitting step 1 on
  // resume must PATCH instead — this also advances enrollment_step to unblock step 2.
  updateStep1: async (companyId, formData, { draft = false } = {}) =>
    await patch(`/v1/company/${companyId}/enroll/step-1`, formData, draft ? { draft: true } : {}, 'form-data'),
  getEnrollment: async (companyId) => await get(`/v1/company/${companyId}/enrollment`),
  enrollStep2: async (companyId, formData, { draft = false } = {}) =>
    await patch(`/v1/company/${companyId}/enroll/step-2`, formData, draft ? { draft: true } : {}, 'form-data'),
  enrollStep3: async (companyId, formData, { draft = false } = {}) =>
    await patch(`/v1/company/${companyId}/enroll/step-3`, formData, draft ? { draft: true } : {}, 'form-data'),

  // ─── Step 4 / DocuSign (integration by another dev) ───────────────────────
  enrollStep4: async (companyId) => await patch(`/v1/company/${companyId}/enroll/step-4`),
  signingStatus: async (companyId) => await get(`/v1/company/${companyId}/enroll/signing-status`),
  refreshSigningUrl: async (companyId) =>
    await post(`/v1/company/${companyId}/enroll/refresh-signing-url`),

  // Step 3 — blank "Surat Kuasa" template the client downloads, fills, re-uploads.
  // Returns an authenticated URL (token in query) — open it to trigger the download.
  downloadSuratKuasaTemplate: () => download('/v1/company/enroll/surat-kuasa-template'),

  // ─── Option lists ──────────────────────────────────────────────────────────
  businessCategories: async (params) => await get('/v1/option/business-category-list', params),
  industries: async (params) => await get('/v1/option/industry-list', params),
  employeeRanges: async (params) => await get('/v1/option/employee-range-list', params),

  // ─── Cascading geographic lookups ─────────────────────────────────────────
  provinces: async (params) => await get('/v1/geographic/provinces', params),
  cities: async (provinceId, params) => await get(`/v1/geographic/cities/${provinceId}`, params),
  districts: async (cityId, params) => await get(`/v1/geographic/districts/${cityId}`, params),
  subdistricts: async (districtId, params) =>
    await get(`/v1/geographic/subdistricts/${districtId}`, params),
  postalCodes: async (subdistrictId, params) =>
    await get(`/v1/geographic/postal-codes/${subdistrictId}`, params),
}
